import styled from "@emotion/styled"
import { PropsWithChildren, useEffect } from "react"
import { useTranslation } from "react-i18next"

declare global {
  interface Window {
    MsCrmMkt: any
  }
}

const Base = styled.div``

type SubscribeFormProps = PropsWithChildren<{
  style?: React.CSSProperties
  className?: string
  questionsAndAnswers: string
  onFormSubmit: () => void
}>

export const SubscribeForm: React.FC<SubscribeFormProps> = ({
  style,
  className,
  questionsAndAnswers,
  onFormSubmit,
}) => {
  const { t } = useTranslation()
  const updateQuestionsAndAnswers = () => {
    const hiddenField = Array.from(
      document.querySelectorAll('form div[hidden*="hidden"] textarea'),
    ).pop()

    if (hiddenField) {
      ;(hiddenField as any).value = questionsAndAnswers
    }
  }

  useEffect(() => {
    const scripts = [
      "https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=1.84.2007",
      "https://mktdplp102cdn.azureedge.net/public/latest/js/ws-tracking.js?v=1.84.2007",
    ].map((src) => {
      const script = document.createElement("script")
      script.src = src
      script.async = true
      document.body.insertBefore(script, document.body.childNodes[0])
      return script
    })

    scripts[0].onload = () => {
      window.MsCrmMkt.MsCrmFormLoader.on("afterFormLoad", function () {
        updateQuestionsAndAnswers()
      })

      window.MsCrmMkt.MsCrmFormLoader.on("afterFormSubmit", function () {
        onFormSubmit()
      })
    }

    return () => {
      scripts.forEach((script) => document.body.removeChild(script))
      window.MsCrmMkt = undefined
      const iframe = document.querySelector('iframe[src*="dynamics.com"]')
      if (iframe) iframe.remove()
    }
  }, [])

  return (
    <Base style={style} className={className}>
      {/* TEST VERSION */}
      {/* <div data-form-block-id="84343956-c81f-ee11-9967-000d3aaa05cb"></div>
      <div id="dXiTyyGcKfKwZSutWS9qq3X7bvCRAb5CaKTwVB93tWKM"></div>
      <div
        className="d365-mkt-config"
        style={{ display: "none" }}
        data-website-id="XiTyyGcKfKwZSutWS9qq3X7bvCRAb5CaKTwVB93tWKM"
        data-hostname="2b1dec343bd740b6afcdfbae0351487a.svc.dynamics.com"
      ></div> */}
      {/* ENGLISH PROD VERSION */}
      <div data-form-block-id="5757f290-8a4d-ee11-be6e-002248a28d66"></div>
      <div id="dJeSIDj8FtbXQCZtA6yupu5IZ5UP3As1vQHecz5i6FQI"></div>
      <div
        className="d365-mkt-config"
        style={{ display: "none" }}
        data-website-id="JeSIDj8FtbXQCZtA6yupu5IZ5UP3As1vQHecz5i6FQI"
        data-hostname="55aa680d454f48e8809d101a6356df54.svc.dynamics.com"
      ></div>
    </Base>
  )
}
